import React, {useState, useCallback, useEffect, useRef} from "react"
import './homepage.css';
import { projData } from "../../globals/data";
import {animate, AnimatePresence, delay, motion, usePresence} from "framer-motion";
import HomeProjectComponent from "../../components/HomeProjectComponent/HomeProjectComponent";
import LocomotiveScroll from 'locomotive-scroll';
import { getGutterWidth } from "../../globals/helpers";
import GridLayout from "../../components/GridLayout/GridLayout";
import { artistVariants, upDownVariants, DTHeroVariants, viewChangeVariants, scrollLineWrapperVariants, auxProjNumVariants, DTSubHeroVariants, hptVariants, filmModeVariants } from "./variants";
import { useLocation, useNavigate } from 'react-router-dom';
import { dsktpExitTiming } from "./variables";
import debounce from 'lodash.debounce';
import { extVideoEndPoint, extVideoInStart, videoShrinkDuration } from "../loader/variables";
import HomeTileComponent from "../../components/HomeTileComponent/HomeTileComponent";



const Homepage = ({setTriggerHomepageToProjectTransition, isFirstLoad, setHomeToArchiveTransitionTrigger, isFromArchive, setCursorText}) => {
    const navigate = useNavigate();
    const activeScaler = 2.25/1.9;
    const [isPresent, safeToRemove] = usePresence();
    const [defaultExit, setDefaultExit] = useState(false);
    
    const [isScrollLineWorking, setIsScrollLineWorking] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);
    const [useMobileVideo, setUseMobileVideo] = useState(null);
    const pageRef = useRef();
    const [firstLoadScalers, setFirstLoadScalers] = useState(null);

    const [selectedIndex, setSelectedIndex] = useState(null);
    const [hasSelected, setHasSelected] = useState(false);
    const heroRefs = useRef([])
    const scrollLineRefs = useRef([]);
    const scrollLineWrapperRefs = useRef(null);
    const heroWrapperRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(2);
    const [slidingWindowTuple, setSlidingWindowTuple] = useState([0, 12])
    const [activeMetaInfo, setActiveMetaInfo] = useState(0);



    const scrollRef = useRef(null);
    const vertItemsRefs = useRef([]);
    const deadColRef = useRef(null);
    const [vertItemsHovered, setVertItemsHovered] = useState([]);
    const [isUserScrolling, setIsUserScrolling] = useState(false);
    const [tileSectionHovering, setTileSectionHovering] = useState(false);
    const [isColumnView, setIsColumnView] = useState(true);
    const [gridTransitionIdxs, setGridTransitionIdxs] = useState(null);
    const [scroller, setScroller] = useState(null);
    const [tileHeight, setTileHeight] = useState(null);
    const [isFilmMode, setIsFilmMode] = useState(true);
    const [removedSnappedTag, setRemovedSnappedTag] = useState("removed_snapped");
    const [scrollNavClicked, setScrollNavClicked] = useState(false);
    const scrollIndRef = useRef(null);
    const tileSectionRef = useRef(null);    
    const noiseRef = useRef(null);
    const viewChangeRef = useRef(null);
    const counterScalerRefs = useRef([]);
    const imgRefs = useRef([]);

    const [MousePosition, setMousePosition] = useState({
        left: 0,
        top: 0
    })


    useEffect(() => {
        let newTarget = window.location.href;
        let lastStub = newTarget.split("/").slice(-1)[0];

        if(!isPresent){
            try{
                scroller.stop();
                pageRef.current.style.overflow = "hidden";
                scroller.destroy();
            }catch{}

            //handle firefox & safari transition bug
            try{
                let lowerBound = Math.max(0, activeIndex - 3);
                let upperBound = Math.min(projData.length - 1, activeIndex + 3);
                for(let i =lowerBound; i< upperBound; i++){
                    if(i !== activeIndex){
                        let tmpRef = vertItemsRefs.current[i];
                        tmpRef.classList.add("no-transition");
                    }
                }
            }catch{}
        }

        if(!isPresent && lastStub){
            try{scroller.destroy()}catch{}
            tileSectionRef.current.style.pointerEvents = "none";
            if(newTarget.includes('projects') && selectedIndex){
                let curActiveEle;
                try{
                    curActiveEle = vertItemsRefs.current[activeIndex];
                    curActiveEle.classList.remove("tmp-hover-hide");
                    curActiveEle.style.opacity = 0.2
                } catch{
                }
                safeToRemove(true)

            } else{
                if(newTarget.includes("archive")){
                    setHomeToArchiveTransitionTrigger([true, isColumnView]);
                    if(isColumnView)vertItemsRefs.current[activeIndex].style.opacity = 1;
                }
                setDefaultExit(true);
                scroller.stop();

                let curActiveEle;
                try{
                    curActiveEle = vertItemsRefs.current[activeIndex];
                    curActiveEle.style.transform = "";
                } catch{

                }

                try{
                    let itemHovTargets = document.getElementsByClassName("snapped");
                    for (let i = 0; i<itemHovTargets.length; i++){
                        itemHovTargets[i].classList.remove("snapped")
                        itemHovTargets[i].classList.remove("is-active")
                    }
                } catch{}
                if(newTarget.includes("contact")){
                    setTimeout(() => {
                        safeToRemove(true);
                    }, 500)
                }else{
                    setTimeout(() => {
                        safeToRemove(true);
                    }, 1500)
                }
            }
        }
    }, [isPresent])

    function handleMouseMove(ev) { 
        setMousePosition({x: ev.pageX, y: ev.pageY});
    }  

    // handle a user hovering on a tile on the column view
    function handleTileMouseEnter(e, idx){
        try{
            if(!isUserScrolling){
                if(idx == activeIndex){
                    vertItemsRefs.current[activeIndex].classList.remove("tmp-hover-hide")
                }else{
                    vertItemsRefs.current[activeIndex].classList.remove("snapped");
                    vertItemsRefs.current[activeIndex].classList.remove("is-active");
                    vertItemsRefs.current[activeIndex].classList.add("tmp-hover-hide");
                    vertItemsRefs.current[activeIndex].style.transform = "scale3d(1, 1, 1)";
                    try{
                        let counterTarg = vertItemsRefs.current[activeIndex].getElementsByClassName("hpt_counter_scaler")[0];
                        counterTarg.style.transform = "scale3d(1, 1, 1)";
                    }catch{}
                }
                imgRefs.current[idx].style.transform = "scale(0.99, 0.99)";
                imgRefs.current[activeIndex].style.transform = "scale(1, 1)";
                vertItemsRefs.current[idx].classList.add("item-hov")
                vertItemsRefs.current[idx].style.transform = "scale3d("+(activeScaler)+", 1, 1)";
                try{
                    let counterTarg = vertItemsRefs.current[idx].getElementsByClassName("hpt_counter_scaler")[0];
                    counterTarg.style.transform = "scale3d(1, "+(activeScaler)+", 1)";
                }catch{}
            }

            let tmptmp = vertItemsHovered.slice(0);
            for(let i=0; i<vertItemsHovered.length; i++){
                tmptmp[i] = false;
            }
            tmptmp[idx] = true;
            setVertItemsHovered(tmptmp)
        }catch{}
    }

    // Handle a users mouse leaving a tile on the columne view
    function handleTileMouseLeave(e, idx){
        vertItemsRefs.current[idx].classList.remove("item-hov");
        vertItemsRefs.current[idx].style.transform = "scale3d(1, 1, 1)";

        try{
            let counterTarg = vertItemsRefs.current[idx].getElementsByClassName("hpt_counter_scaler")[0];
            counterTarg.style.transform = "scale3d(1, 1, 1)";
        }catch{}

        imgRefs.current[idx].style.transform = "scale(1, 1)";

        let tmptmp = vertItemsHovered.slice(0);
        for(let i=0; i<vertItemsHovered.length; i++){
            tmptmp[i] = false;
        }
        setVertItemsHovered(tmptmp)
    }

    const debounceActiveMetaReset = useCallback(
        debounce((idx) => {
            setActiveMetaInfo(idx);
        }, 200), []
    )

    const debounceActiveMetaHover = useCallback(
        debounce((idx) => {
          setActiveMetaInfo(idx);
        }, 100),
        []
      );

    function handleTileColumnHover(isEntering){
        if(!hasSelected && !defaultExit){
            if (isEntering){
                tileSectionRef.current.classList.add("column-active");
            }
            else{
                vertItemsRefs.current[activeIndex].classList.remove("tmp-hover-hide")
                vertItemsRefs.current[activeIndex].classList.add("snapped");
                vertItemsRefs.current[activeIndex].classList.add("is-active");
                vertItemsRefs.current[activeIndex].style.transform = "scale3d("+(activeScaler)+", 1, 1)";
                try{
                    let counterTarg = vertItemsRefs.current[activeIndex].getElementsByClassName("hpt_counter_scaler")[0];
                    counterTarg.style.transform = "scale3d(1, "+(activeScaler)+", 1)";
                }catch{}
                tileSectionRef.current.classList.remove("column-active");   
                imgRefs.current[activeIndex].style.transform = "scale(0.99, 0.99)";
            }
            setTileSectionHovering(isEntering);
        }
    }

    function handleViewChange(){
        viewChangeRef.current.style.pointerEvents = "none";
        try{
            if(isColumnView){
                imgRefs.current[activeIndex].style.transform = "scale(1, 1)";
            }
            else{
                imgRefs.current[activeIndex].style.transform = "scale(1, 1)";
                let act = vertItemsRefs.current[activeIndex];
                let tmp = act.getElementsByClassName("grid-item__hover")[0];
                tmp.style.opacity = 1
            }
        }catch{}
        setTimeout(() => {
            viewChangeRef.current.style.pointerEvents = null;
        }, 2000);
        if(isColumnView){
            scroller.stop();
            // bring opacity of all other elements up

            vertItemsRefs.current[activeIndex-2].style.opacity = 1;
            vertItemsRefs.current[activeIndex-2].style.setProperty( 'transition', 'all 1s cubic-bezier(0.25, 1, 0.5, 1)', 'important' );

            vertItemsRefs.current[activeIndex-1].style.opacity = 1;
            vertItemsRefs.current[activeIndex-1].style.setProperty( 'transition', 'all 1s cubic-bezier(0.25, 1, 0.5, 1)', 'important' );

            vertItemsRefs.current[activeIndex].style.opacity = 1;
            vertItemsRefs.current[activeIndex].style.setProperty( 'transition', 'all 1s cubic-bezier(0.25, 1, 0.5, 1)', 'important' );

            vertItemsRefs.current[activeIndex+1].style.opacity = 1;
            vertItemsRefs.current[activeIndex+1].style.setProperty( 'transition', 'all 1s cubic-bezier(0.25, 1, 0.5, 1)', 'important' );

            vertItemsRefs.current[activeIndex+2].style.opacity = 1;
            vertItemsRefs.current[activeIndex+2].style.setProperty( 'transition', 'all 1s cubic-bezier(0.25, 1, 0.5, 1)', 'important' );
            
            
            // remove styling from active element
            vertItemsRefs.current[activeIndex].classList.remove("snapped");
            vertItemsRefs.current[activeIndex].classList.remove("is-active");
            
            
            // shrink active element
            vertItemsRefs.current[activeIndex].style.transform = "scale3d(1, 1, 1)";

            // get rid of video from active element
            try{vertItemsRefs.current[activeIndex].getElementsByClassName("grid-item__hover")[0].style.opacity = 0}catch{}

            try{
                let tmp = vertItemsRefs.current[activeIndex].getElementsByClassName("hpt_counter_scaler")[0];
                tmp.style.transform = "scale3d(1, 1, 1)"
            }catch{}
            
            
            setTimeout(() => {
                vertItemsRefs.current[activeIndex-2].style.opacity = 0;
                vertItemsRefs.current[activeIndex-2].style.transition = null;

                vertItemsRefs.current[activeIndex-1].style.opacity = 0;
                vertItemsRefs.current[activeIndex-1].style.transition = null;

                vertItemsRefs.current[activeIndex].style.opacity = 0;
                vertItemsRefs.current[activeIndex].style.transition = null;

                vertItemsRefs.current[activeIndex+1].style.opacity = 0;
                vertItemsRefs.current[activeIndex+1].style.transition = null;

                vertItemsRefs.current[activeIndex+2].style.opacity = 0;
                vertItemsRefs.current[activeIndex+2].style.transition = null;
            }, 1000)
            

        } else{
            
            setTimeout(() => {
                vertItemsRefs.current[activeIndex-2].style.opacity = 0.2;
                vertItemsRefs.current[activeIndex-1].style.opacity = 0.2;
                vertItemsRefs.current[activeIndex].style.opacity = 1;
                vertItemsRefs.current[activeIndex+1].style.opacity = 0.2;
                vertItemsRefs.current[activeIndex+2].style.opacity = 0.2;
                scroller.start();
            }, 1400)
        }
        setIsColumnView(!isColumnView)
    }

    function handleFilmModeClick(){
        setIsFilmMode(!isFilmMode);
    }

    // Basic resize handling
    function responsiveResize(){
        let curHeight = window.innerHeight;
        // 5 is fixed number of elements in view for column view on desktop devices
        let assumedNumEles = 5;
        let newTileHeight = curHeight/assumedNumEles;

        // Mobile videos are used for smaller widths to save bandwidth and decrease unnecessary load times 
        let maxTileWidth = (window.innerHeight/5) * 2.25;
        if(maxTileWidth <= 600)setUseMobileVideo(true);
        else setUseMobileVideo(false);

        setTileHeight(newTileHeight);
    }


    // Manages the sliding window tracking  - Sliding window keeps track of 13 closest elements in view.
    // 13 is the number of elements the grid view can hold - as active index changes (user scrolls) we want to move this sliding window start and end to 
    // reflect this - tracking this incorrectly leads to an incorrect transition to the grid-view so must match and be updated correctly.
    useEffect(() => {
        const windowSize = 12;
        const uniDirectionSize = windowSize/2;

        let slidingStart = 0;
        let slidingEnd = 0;

        if(activeIndex < uniDirectionSize){
            let missingFront = Math.abs(activeIndex - uniDirectionSize);
            slidingStart = 0;
            slidingEnd = activeIndex + uniDirectionSize + missingFront;
        } else if(activeIndex + uniDirectionSize >= (projData.length - 1)){
            let missingEnd = Math.abs((projData.length - 1) - (activeIndex + uniDirectionSize));
            slidingEnd = projData.length - 1;
            slidingStart = activeIndex - uniDirectionSize - missingEnd;
        } else{
            slidingStart = activeIndex - uniDirectionSize;
            slidingEnd = activeIndex + uniDirectionSize;
        }

        setSlidingWindowTuple([slidingStart, slidingEnd])
    }, [activeIndex])

    const hideNavScrollTicker = () => {
        try{scrollLineWrapperRefs.current.classList.add("hide-scroll-lines")}catch{}
    }

    useEffect(() => {
        setGridTransitionIdxs([activeIndex-2, activeIndex+2])
        setIsFilmMode(isColumnView)
        if(!isColumnView){
            hideNavScrollTicker();
        }
    }, [isColumnView])

    useEffect(() => {
        if(vertItemsRefs.current){
            vertItemsRefs.current[2].style.transform = "scale3d("+(activeScaler)+", 1, 1)";
        }
    }, [vertItemsRefs])    

    useEffect(() => {
        setTimeout(() => {
            if(!tileSectionHovering && !isUserScrolling){
                let relativeIdx = activeIndex;
                let translateAmount = (relativeIdx*204.22);
            }
        }, 100)
    }, [tileSectionHovering])


    useEffect(() => {
        // animate out the grid line flanking the hovered point
        if(isUserScrolling){
            // topHorizRef.current.style.transform = "translate3d(0, 0px, 0)";
            // bottomHorizRef.current.style.transform = "translate3d(0, 0px, 0)";
            // leftVertRef.current.style.transform = "translate3d(0px, 0, 0)";
            // rightVertRef.current.style.transform = "translate3d(0px, 0, 0)";
        
            vertItemsRefs.current.map((item, idx) => {
                if(idx !== activeIndex){
                    item.classList.remove("snapped");
                    item.classList.remove("is-active");
                }
                item.classList.remove("item-hov");
                item.classList.remove("tmp-hover-hide");
            })
        }else{
            // If user isnt scrolling and the user has their cursor still within the columns
            // (this accounts for a situation where the user scrolls while the cursor is still in the center of the page,
            // and then the scrolling stops)
            // We then use the mouse positions we've been tracking to check which element is now being hovered
            if(tileSectionHovering){
                let viewportHeight = window.innerHeight;
                let div = MousePosition.y/viewportHeight;
                
                let hovIndex = Math.abs(Math.ceil((div * 5)-1));
                let offset = hovIndex - 2;

                if(offset !== 0 && hovIndex){
                    let actualIndex = activeIndex + (hovIndex - 2);
                    // Need to get the actual index by taking the currently active index and
                    // using the hovIndex as an offset to the active index
                    vertItemsRefs.current[actualIndex].classList.add("item-hov", removedSnappedTag);
                    vertItemsRefs.current[activeIndex].classList.add("tmp-hover-hide");
                    vertItemsRefs.current[activeIndex].classList.remove("snapped");
                    vertItemsRefs.current[activeIndex].classList.remove("is-active");
                }
            }
        }
    }, [isUserScrolling])

    useEffect(() => {
        if(scrollRef.current && tileHeight){
            let mountDelay = isFirstLoad ? extVideoEndPoint*1000 : 0;
            pageRef.current.style.overflow = "hidden";
            setTimeout(() => {
                pageRef.current.style.overflow = null;
                let tmpScroll = new LocomotiveScroll({
                    el: scrollRef.current,
                    smooth: true,
                    lerp: 0.2,
                    initPosition: {x: 0, y:0},
                    repeat: true,
                    getSpeed: true,
                    multiplier: 0.5,
                    touchMultiplier: 3,
                    getDirection: true,
                    smartphone: {
                        smooth: true,
                        direction: 'vertical'
                    },
                    tablet: {
                        smooth: true,
                        direction: 'vertical',
            
                    },
                    reloadOnContextChange: true
                });
                setScroller(tmpScroll);
                let elementHeight = tileHeight;
                let notAdjustingScroll = true;
                let hasClearedPrevSnapEles = true;

                let isFreshWindow = true;
                let isFirst = 1;

                let isScrolling; // Timeout variable for detecting scroll end
                
                tmpScroll.on('scroll', (args) => {
                    clearTimeout(isScrolling);
                    
                    // absolute scroll speed
                    let absSpeed = Math.abs(args.speed);
                    
                    // Scroll progress through the page
                    let tmpScrollProg = args.scroll.y/args.limit.y
                    setScrollProgress(tmpScrollProg)

                    // If we're within the bounds of the page
                    if(tmpScrollProg > 0 & tmpScrollProg < 1){
                        if(!notAdjustingScroll){
                            // set absSpeed to 0 so bounce any adjustments
                            absSpeed = 0;
                            isFreshWindow = true;
                            setIsUserScrolling(false);
                        }
                        else if(args.scroll.y > 1 && args.scroll.y != args.limit.y){
                            // If not adjusting scroll and our scroll delta is larger than 1 & less than the limit proceed
                            if(isFirst || (!hasClearedPrevSnapEles && absSpeed > 1)){
                                // If is first or has not cleared previous snapped elements

                                //Set flag to indicate user is scrolling
                                setIsUserScrolling(true);

                                // unset isFirst
                                isFirst = 0;


                                // removes the effects on the currently active element (center ele)
                                let targetsToClear = document.getElementsByClassName("snapped");
                                for(let i = 0; i< targetsToClear.length; i++){
                                    let curTarg = targetsToClear[i];
                                    curTarg.classList.remove("snapped");
                                    curTarg.classList.remove("is-active");
                                    curTarg.classList.remove("item-hov");
                                    curTarg.classList.remove("tmp-hover-hide");
                                    curTarg.classList.add(removedSnappedTag)
                                    let imgWrapper = curTarg.getElementsByClassName("h-img-wrapper")[0]
                                    imgWrapper.style.transform = "scale(1, 1)";
                                }
                                hasClearedPrevSnapEles=true;
                            }else{
                                // Perform calculations for animating in entering/exiting elements
                                let targetScroll = args.delta.y;
                                let division = ((targetScroll/elementHeight));

                                let remainder;
                                let indexNumber;
                                let enteringElement;
                                let exitingElement;
                                let enteringProgress;
                                let exitingProgress;
                                let curIndex;

                                let currentScroll = args.scroll.y;
                                let heroProg = currentScroll/((window.innerHeight/5));

                                // If our hero is still visible then do some translation on it, some simple calculations to give
                                // it a slight parallax effect
                                if(heroProg < 1){
                                    for(let i=0; i< heroRefs.current.length; i++){
                                        let curHero = heroRefs.current[i];
                                        let maxTranslate = ((i+1) * 15) - (10 * (i/heroRefs.current.length));
                                        let translateVal = maxTranslate * heroProg;
                                        curHero.style.transform = `translate3d(-50%, calc(-50% + ${translateVal}px),0)`
                                    }
                                    if(heroWrapperRef.current){
                                        let scaler = (0.9 + (1-heroProg)*0.1)
                                        heroWrapperRef.current.style.transform = "translate3d(-50%,"+-args.scroll.y+"px,0) scale3d("+scaler+","+scaler+", 1)"
                                        heroWrapperRef.current.style.opacity = 1 - (1.2 * heroProg)
                                    }
                                }


                                // Consider directionality to get entering/exiting element
                                if(args.direction == 'down'){
                                    curIndex = Math.floor(division-0.5)
                                    indexNumber = Math.floor(division);
                                    remainder = division - indexNumber;

                                    exitingProgress = 1 - (-0.5 + division - curIndex);
                                    enteringElement = vertItemsRefs.current[indexNumber + 3];
                                    exitingElement = vertItemsRefs.current[curIndex + 2];
                                    enteringProgress = (-1 * remainder) + 0.5;
                                    if (enteringProgress < 0){
                                        enteringProgress = 1 - enteringProgress
                                    } else{
                                        enteringProgress = 1 - enteringProgress
                                    }
                                } else{
                                    curIndex = Math.ceil(division + 0.5)
                                    indexNumber = Math.ceil(division);

                                    remainder = indexNumber - division;
                                    enteringProgress = remainder;
                                    exitingProgress = 2 - (0.5 - division + curIndex);
                                    enteringElement = vertItemsRefs.current[indexNumber+1];
                                    exitingElement = vertItemsRefs.current[curIndex+2];

                                }
                                
                                // Have calculated the entering/exiting progress based off of the above calculations,
                                // can now use these to animate the opacity of the elements
                                // The scaling is simply done by assigning the activeScaler value and letting css transitions handle animation
                                // Can use the enteringprogress/exiting progress for the transform the same way, but found it ran better this way. 
                                try{
                                    let enteringCounter = enteringElement.getElementsByClassName("hpt_counter_scaler")[0];
                                    enteringCounter.style.transform =  "scale3d(1, "+(activeScaler)+", 1)";
                                }catch{}
                                try{
                                    let exitingCounter = exitingElement.getElementsByClassName("hpt_counter_scaler")[0];
                                    exitingCounter.style.transform =  "scale3d(1, 1, 1)";
                                }catch{}
                                enteringElement.style.opacity = Math.max(enteringProgress.toFixed(3), 0.2);
                                enteringElement.style.transform = "scale3d("+(activeScaler)+", 1, 1)";
                                if(exitingElement.style.opacity > 0.25)
                                    exitingElement.style.opacity = Math.max(0.2, exitingProgress.toFixed(3)); 
                                exitingElement.style.transform = "scale3d(1, 1, 1)";

                                // set timeout to start snapping if user hasnt scrolled within a given timeout period
                                isScrolling = setTimeout(() => {
                                    if (notAdjustingScroll) {
                                        // stop the locomotive scroll instance from firing
                                        tmpScroll.stop();

                                        // set the states fo the adjacent elements to the center (scale them to normal size and)
                                        // add snapped class to target element being snapped to
                                        let division = targetScroll/elementHeight;
                                        let indexNumber = Math.round(division);
                                        try{
                                            vertItemsRefs.current[indexNumber + 1].style.transform = "scale3d(1, 1, 1)";
                                            vertItemsRefs.current[indexNumber + 3].style.transform = "scale3d(1, 1, 1)";
                                            vertItemsRefs.current[indexNumber + 2].classList.add("snapped");

                                            // 0.99 to hide the image edge from showing underneath the video that will now autoplay on the snapped element
                                            // Some sort of rendering bug in browsers means identical sized images and videos overlaied within a container with a
                                            // overflow: hidden set can cause the edge of the element underneath (image in this case) to show still, scaling to 0.99 pulls
                                            // the edges of the element back
                                            imgRefs.current[indexNumber + 2].style.transform = "scale(0.99, 0.99)";
                                            vertItemsRefs.current[indexNumber + 2].classList.add("is-active");
                                            vertItemsRefs.current[indexNumber + 2].classList.remove(removedSnappedTag);

                                            // Offset by +2 due to first two elements being empty
                                            setActiveIndex(indexNumber+2);
                                            if(!tileSectionHovering){
                                                setActiveMetaInfo(indexNumber);
                                            }

                                            // This gives the location to snap to - top point of the given index being snapped to
                                            let snapToLocation = indexNumber*elementHeight;

                                            // now adjusting scroll so need to set this to false for blocking
                                            notAdjustingScroll = false;

                                            // Need to signify that previously snapped elements havent been
                                            // cleared so now trigger the clearing process
                                            hasClearedPrevSnapEles=false;

                                            // On snap need to ensure current   element in view is animated to full
                                            // opacity and those on either side are animated to lowest opacity
                                            tmpScroll.scrollTo('top', {
                                                'offset': snapToLocation,
                                                'duration': 500,
                                                'easing': [0.16, 1, 0.3, 1],
                                                'callback': () => {
                                                    // reset variables to signify scrolling is finished
                                                    // only design to bounce activity while auto scrolling for user
                                                    // that's all this is supposed to do
                                                    setTimeout(() => {
                                                        // When snapping complete set these to reset state and allow the scrolling to start again
                                                        notAdjustingScroll = true;
                                                        setIsUserScrolling(false);
                                                        
                                                        tmpScroll.start()
                                                    }, 100)
                                                }
                                            })

                                            // Need to remove all calculated opacity's for items that aren't activeIndex
                                            // (indexNumber + 2)
                                            vertItemsRefs.current.map((item, idx) => {
                                                if(!(idx == (indexNumber + 2)) && (item.style.opacity > 0.25 || item.classList.contains("snapped"))){
                                                    item.classList.add(removedSnappedTag);
                                                    imgRefs.current[idx].style.transform = "scale(1, 1)";
                                                    item.classList.remove("snapped");
                                                    item.classList.remove("is-active");
                                                    item.style.opacity = 0.2;
                                                }
                                            })
                                        }catch{}
                                    }
                                }, 25); // Debounce duration for user scroll detection
                            }
                        }
                    } else{
                        setIsUserScrolling(false);
                        if(tmpScrollProg <= 0){
                            setActiveIndex(2);
                            setActiveMetaInfo(0)
                            vertItemsRefs.current[2].classList.add("snapped");
                            vertItemsRefs.current[2].classList.add("is-active");
                        } else{
                            let endLoc = vertItemsRefs.current.length - 5;
                            setActiveIndex(endLoc + 2);
                            setActiveMetaInfo(endLoc)
                            vertItemsRefs.current[endLoc+2].classList.add("snapped");
                            vertItemsRefs.current[endLoc+2].classList.add("is-active");

                            vertItemsRefs.current.map((item, idx) => {
                                if(!(idx == (endLoc + 2)) && (item.style.opacity > 0.25 || item.classList.contains("snapped"))){
                                    item.classList.add(removedSnappedTag);
                                    try{imgRefs.current[idx].style.transform = "scale(1, 1)";;}catch{}
                                    item.classList.remove("snapped");
                                    item.classList.remove("is-active");
                                    item.style.opacity = 0.2;
                                }
                            })
                        }
                    }
                });
            }, (mountDelay))
            
        }
    }, [scrollRef, tileHeight])

    const navScrollTicker = () => {
        let targNum = projData.length;
        let divider = 1/(targNum-1);

        let activeTarg = Math.round(scrollProgress/divider);
        let priorSibling = Math.max(0, activeTarg-1);
        let postSibling = Math.min(projData.length -1, activeTarg + 1);

        try{
            scrollLineRefs.current[activeTarg].style.transform = "scaleX(1.75)";
            scrollLineRefs.current[activeTarg].style.background = "var(--light-color)";
            if(activeTarg > 0){
                scrollLineRefs.current[priorSibling].style.transform = "scaleX(1.25)";
                scrollLineRefs.current[priorSibling].style.background = "var(--unselected-color)";
            }

            if(postSibling !== activeTarg){
                scrollLineRefs.current[postSibling].style.transform = "scaleX(1.25)";
                scrollLineRefs.current[postSibling].style.background = "var(--unselected-color)";
            }
            for(let i=0; i<scrollLineRefs.current.length; i++){
                if(i < priorSibling || i > postSibling){
                    scrollLineRefs.current[i].style.transform = "scaleX(1)";
                    scrollLineRefs.current[i].style.background = "var(--grid-lines)";
                }
            }
        } catch{}
    }

    // When scroll progress updated, update the scroll ticker (lines indicating the scroll progress)
    useEffect(() => {
        navScrollTicker();
    }, [scrollProgress])

    function scrollLineClick(idx){
        if(!isScrollLineWorking){
            let targOffset = (window.innerHeight/5) * idx;
            setScrollNavClicked(true);
            setIsScrollLineWorking(true);
            scroller.stop();
            scroller.scrollTo('top', {
                'offset': targOffset,
                'duration': 1000,
                'easing': [0.16, 1, 0.3, 1],
                'callback': () => {
                    scroller.start();
                    setScrollNavClicked(false);
                    setTimeout(() => {
                        setIsScrollLineWorking(false);
                    }, 750)
                }
            })
        }
    }

    useEffect(() => {
        setTriggerHomepageToProjectTransition(false);

        //Setup listener to resize
        responsiveResize();
        window.addEventListener('resize', responsiveResize, false);

        // Used for calculating what to scale the first load animation tile by in order to get it to full screen and animate down to the correct
        // size to match perfectly with the first element.
        if(isFirstLoad){
            let yFLScale = (window.innerHeight / ((window.innerHeight/5) - 20))
            let xFlScale = yFLScale * (2.25 /1.9);
            let targAR = ((window.innerHeight/5)*2.25)/((window.innerHeight/5)-20);
            setFirstLoadScalers([xFlScale, yFLScale, targAR]);
        }

        // Wait to add the is-active tag to the first element (index 2 as index 0 and 1 are fummy (blank) entries)
        // if it's first load we are playing the intro video, so need to wait for endpoint (extVideoEndPoint * 1000), otherwise 
        // we must have navigated to the hompage from another page, so wait half a second
        if(!isFirstLoad){
            setTimeout(() => {
                try{vertItemsRefs.current[2].classList.add("is-active")} catch{}
            }, 550)
        }else{
            setTimeout(() => {
                try{vertItemsRefs.current[2].classList.add("is-active")} catch{}
            }, extVideoEndPoint*1000)
        }
        try{
            // Counter scaling as the wrapper gets scaled activeScaler in width, the counter scaler scales the content
            // of the container by activeScaler to keep its intrinsic aspect ratio the same (no warping), but still being cut off by its
            // wrapper which has overflow: hidden.
            let targetCounter = vertItemsRefs.current[activeIndex].getElementsByClassName("hpt_counter_scaler")[0];
            targetCounter.style.transform = `scale3d(1,${activeScaler},1)`;
        }catch{}

        if(window.innerWidth > 775){
            let targetWidth = (window.innerWidth - (getGutterWidth(window.innerWidth).main *2));
            let tmpHeight = Math.min(targetWidth * (9/16), window.innerHeight - 180)
            let tileImgHeight = (window.innerHeight/5) - 20;
            let tileImgWidth = (2.25*(window.innerHeight/5));
            let bgScaler = [targetWidth/tileImgWidth, tmpHeight/tileImgHeight];
        }

        setCursorText("");

        // Have to detect and add logic for safari due to bugs exclusive to this browser
        let isSafari = window.safari !== undefined;
        if(isSafari){setRemovedSnappedTag("removed_snapped_saf")}

        vertItemsRefs.current[2].classList.add("snapped");
        let tmpBool = []
        projData.map((item, idx) => {
            tmpBool.push(false)
        })
        setVertItemsHovered(tmpBool);

        // remove listeners
        return() => {
            try{window.removeEventListener('resize', responsiveResize)}catch{}
            try{scroller.destroy()}catch{}
        }
    }, []);

    const handleItemSelection = (selected_idx) => {

        // remove film overlay
        setIsFilmMode(false);
        
        // set selected index
        setSelectedIndex(selected_idx)

        //Trigger the omepage to project transition overlay for the selected_idx - 2 (offset by 2 due to top two elements being empty)
        setTriggerHomepageToProjectTransition([selected_idx-2, 0])

        // set hasSelected flag to indicate the exit transition is a project transition
        setHasSelected(true)

        // Add is-selected classname to selected index
        // We dont use -2 offset as we're accessing the vertItemsRefs which contains the two starting empty elements
        let targetElement = vertItemsRefs.current[selected_idx]
        targetElement.classList.add('is-selected')
        targetElement.style.opacity = 1;

        // Need to scale down the hpt_counter_scaler
        try{
            let targetCounter = targetElement.getElementsByClassName("hpt_counter_scaler")[0];
            targetCounter.style.transform = "scale3d(1,1,1)";
        }catch{}

        // Discovered a bug here which when framer-motion is running an exit animation on an element which has a 
        // css transition property set on FF or Safarit, the browser doesn't know how to run the animation properly so I developed
        // a fix for this below:

        // Need to remove all transition properties to fix double animation bug on FF & Safari
        let operatingWindow = [Math.max(0, activeIndex-3), Math.min(activeIndex+4)];
        for(let i =operatingWindow[0]; i<operatingWindow[1]; i++){
            try{
                vertItemsRefs.current[i].classList.add("no-transition");
            }catch{}
        }

        // Navigate to the project.
        let navLocation = projData[selected_idx-2].title;
        navigate(`/projects/${navLocation}`, {state:{isFromHome:true}})
    }

    return (
        <>
            <motion.div 
                key={"homepage_wrapper"}
                className={`homepage_wrapper`}
                initial="initial"
                animate="animate"
                exit={selectedIndex ? "projExit" : "exit"}
                ref={pageRef}
            >
                <div 
                    key={"home_content_wrapper"}
                    className="home_content_wrapper"
                >
                    <div 
                        key={"scroll_wrapper"}
                        className="scroll_wrapper" 
                        id="main-container"
                        data-scroll-id="hey"
                        data-scroll-container
                        ref={scrollRef}
                    > 
                        <div 
                            key={"vert_wrapper"}
                            className="vertical_project_wrapper"
                            data-scroll-section
                            id="main_content_scroll_container"
                            ref={tileSectionRef}
                            onMouseEnter={() => {
                                handleTileColumnHover(true);
                                debounceActiveMetaReset.cancel();
                            }}
                            onMouseLeave={() => {
                                if(!hasSelected && !defaultExit){
                                    handleTileColumnHover(false);
                                    debounceActiveMetaReset.cancel();
                                    debounceActiveMetaReset(activeIndex-2);
                                }
                            }}
                            style={{
                                zIndex: 10,
                                pointerEvents: !isColumnView ? 'none' : null
                            
                            }}
                        >
                             <div className="home_hero__wrapper"
                                style={{
                                    position: "absolute",
                                    top: "60px",
                                    width: "100vw",
                                    height: "calc(40vh - 70px)",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    lineHeight: 0.85,
                                    pointerEvents: "none",
                                    letterSpacing: "10px",
                                    transition: "transform 0.05s ease",
                                    zIndex: 5,
                                    fontFamily: "Sporty Pro Black",
                                    fontSize: "min(10vw, 320px)",
                                    letterSpacing: "-4px"
                                }}
                                ref={heroWrapperRef}
                            >
                                <div className="main-hero__wrapper"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        zIndex: 5,
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        width: "100%",
                                        height: "50%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                    id="noisy"
                                >
                                    <div className="hero_img__wrapper">
                                        <motion.img 
                                            className="home-logo-upper"
                                            src="../media/branding/logo-upper.png"    
                                            initial="initial"
                                            animate={isColumnView ? "animate" : "exit"}
                                            exit="exit"
                                            variants={DTHeroVariants}
                                            custom={[0, selectedIndex, window.location.href.includes("archive"), isFirstLoad]}
                                        />
                                    </div>
                                    <div className="lower-logo-wrapper">
                                        <motion.img
                                            className="home-lower-logo"
                                            src="../media/branding/logo-lower.png"
                                            initial="initial"
                                            animate={isColumnView ? "animate" : "exit"}
                                            exit="exit"
                                            variants={DTSubHeroVariants}
                                            custom={[0, 
                                                selectedIndex, 
                                                window.location.href.includes("archive"), 
                                                isFirstLoad,
                                                1
                                            ]}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`h_ctent__wrapper`}>
                                {
                                    projData && [null, null].concat(projData.concat([null, null])).map((projItem, p_idx) => (
                                        <div
                                            className="hpt__wrapper" 
                                            style={{position: "relative", padding: 10, height: "20dvh"}}

                                        >
                                            <motion.div 
                                                key={p_idx+"_vert_eles"}
                                                className={`home_project_tile`}
                                                ref={el => vertItemsRefs.current[p_idx] = el}
                                                onClick={() => handleItemSelection(p_idx)}
                                                onMouseEnter={(e) => {
                                                    if(projItem && !hasSelected){
                                                        handleTileMouseEnter(e, p_idx);
                                                        debounceActiveMetaHover(p_idx-2);
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if(projItem && !hasSelected){
                                                        handleTileMouseLeave(e, p_idx);
                                                        debounceActiveMetaHover.cancel();
                                                    }
                                                }}
                                                exit={
                                                    isColumnView ?
                                                        selectedIndex && p_idx == selectedIndex ? "projExit" 
                                                            : selectedIndex ? "notSelectedProjExit" 
                                                                : (((p_idx - activeIndex) + 2) < 5) && (((p_idx - activeIndex) + 2) >= 0) 
                                                                    ? !window.location.href.includes("archive") || (p_idx !== activeIndex) ? "exit" : null
                                                                        : "animate"
                                                    : ""
                                                }
                                                variants={hptVariants}
                                                custom={[selectedIndex-activeIndex, (p_idx - activeIndex) + 2, p_idx < 5]}
                                            >
                                                <div 
                                                    className="scaler_counter__wrapper"
                                                    style={{ height: "100%", width: "100%"}}
                                                >
                                                    { 
                                                        projItem && isFromArchive !== null && useMobileVideo !== null &&
                                                        <HomeTileComponent 
                                                            counterScalerRefs={counterScalerRefs}
                                                            imgRefs={imgRefs}
                                                            p_idx={p_idx}
                                                            selectedIndex={selectedIndex}
                                                            activeIndex={activeIndex}
                                                            isFromArchive={isFromArchive}
                                                            isFirstLoad={isFirstLoad}
                                                            projItem={projItem}
                                                            useMobileVideo={useMobileVideo}
                                                            activeMetaInfo={activeMetaInfo}
                                                            hasSelected={hasSelected}
                                                            defaultExit={defaultExit}
                                                            
                                                        />
                                                    }
                                                    </div>
                                                </motion.div>
                                                
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fl-home-wrapper">
                    {
                        firstLoadScalers &&
                        <motion.div
                            className="fl-video"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                height: "100dvh",
                                width: `calc(100dvh * ${firstLoadScalers[2]})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                zIndex: 99,
                                backgroundImage: 'url('.concat(projData[0].thumbnails.desktop,')'),
                                trasnformOrigin: "center"
                            }}
                            initial={{
                                opacity: 1,
                                transform: "translate3d(-50%, -50%, 0) scale3d(1, 1, 1)"
                            }}
                            animate={{
                                opacity: 0,
                                transform: `translate3d(-50%, -50%, 0) scale3d(${1/firstLoadScalers[1]}, ${1/firstLoadScalers[1]}, 1)`,
                                transition: {
                                    delay: extVideoInStart,
                                    duration: videoShrinkDuration,
                                    ease: [0.87, 0, 0.13, 1],
                                    opacity: {
                                        duration: 0.25,
                                        delay: extVideoEndPoint
                                    }
                                }
                            }}
                        />
                    }
                </div>
                <div className="home_aux_wrapper padding_1">
                    <div className="home_left_col">
                        <motion.div
                            className="scroll_line__wrapper dsktp_scroll_line__wrapper"
                            ref={scrollLineWrapperRefs}
                            variants={scrollLineWrapperVariants}
                            custom={isFirstLoad}
                            onMouseEnter={() => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.add("cursor-active")
                                }catch{}
                            }}
                            onMouseLeave={() => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.remove("cursor-active")
                                }catch{}
                            }}
                        >
                            {projData.map((item, idx) => (
                                <div onClick={() => scrollLineClick(idx)}>
                                    <span 
                                        className="scroll-line" 
                                        ref={el => scrollLineRefs.current[idx] = el}
                                        
                                    />
                                </div>
                            ))}
                        </motion.div>
                        <div
                            className="mode_adjust_wrapper" 
                            onClick={handleFilmModeClick}
                            onMouseEnter={() => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.add("cursor-active")
                                }catch{}
                            }}
                            onMouseLeave={() => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.remove("cursor-active")
                                }catch{}
                            }}
                        >
                            <div
                                className="mode_adjust_ovr"
                                key="film_mode_analog_wrpr"
                            >
                                <motion.span
                                    variants={filmModeVariants}
                                    key="film_mode_analog"
                                    initial="initial"
                                    animate={isFilmMode && !selectedIndex && isColumnView ? "animate" : "exit"}
                                    exit={selectedIndex ? "projExit" : "exit"}
                                    custom={isFirstLoad}
                                >ANALOG&nbsp;</motion.span>
                            </div>
                            <div 
                                className="mode_adjust_ovr"
                                key="film_mode_digi_wrpr"
                            >
                                <motion.span
                                    initial="initial"
                                    animate={!isFilmMode && !selectedIndex && isColumnView ? "animate" : "exit"}
                                    exit={selectedIndex ? "projExit" : "exit"}
                                    variants={filmModeVariants}
                                    key="film_mode_digi"
                                >
                                    DIGITAL&nbsp;
                                </motion.span>
                            </div>

                        </div>
                        <motion.div 
                            className="title_wrapper"
                            variants={upDownVariants}
                        >
                            <span key="title_space">&nbsp;</span>
                                <AnimatePresence mode="wait">
                                {projData && projData.map((item, idx) => (
                                    idx == activeMetaInfo &&
                                    <motion.span
                                        initial="initial"
                                        animate={selectedIndex ? "projExit" : activeMetaInfo == idx && isColumnView ? "animate" : "inital"}
                                        exit="exit"
                                        variants={artistVariants}
                                        className="video_name"
                                        custom={[1, isFirstLoad]}
                                        key={item.title + "_title_eles_" + idx}
                                    >
                                        {item.title}
                                    </motion.span>
                                ))}
                                </AnimatePresence>
                        </motion.div>
                    </div>
                    <div
                        className="dead_center_col"
                        ref={deadColRef}
                    />
                    <div className="home_right_col">
                        <div className="mid_right">
                            <div 
                                className={`display_selector`}
                                ref={viewChangeRef}
                                onClick={() => {
                                    handleViewChange()
                                }}
                                onMouseEnter={() => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.add("cursor-active")
                                    }
                                    catch{

                                    }
                                }}  
                                onMouseLeave={() => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.remove("cursor-active")
                                    }
                                    catch{

                                    }
                                }} 
                                
                            >
                                <motion.span
                                    variants={viewChangeVariants}
                                    initial="initial"
                                    animate={isColumnView ? "colMode" : "gridMode"}
                                    exit="exit"
                                    custom={[1, 0, 0, isFirstLoad]}
                                />
                                <motion.span
                                    variants={viewChangeVariants}
                                    initial="initial"
                                    animate={isColumnView ? "colMode" : "gridMode"}
                                    exit="exit"
                                    custom={[0, 1, 0, isFirstLoad]}
                                />
                                <motion.span
                                    variants={viewChangeVariants}
                                    initial="initial"
                                    animate={isColumnView ? "colMode" : "gridMode"}
                                    exit="exit"
                                    custom={[0, 0, 1, isFirstLoad]}
                                />
                            </div>
                        </div>

                        <motion.div 
                            className="artist_wrapper"
                            variants={upDownVariants}    
                        >
                            <span>&nbsp;</span>
                                <AnimatePresence mode="wait">
                                {projData && projData.map((item, idx) => (
                                    idx == activeMetaInfo &&
                                    <motion.span
                                        initial="initial"
                                        animate={selectedIndex ? "projExit" : activeMetaInfo == idx && isColumnView ? "animate" : "inital"}
                                        exit="exit"
                                        variants={artistVariants}
                                        custom={[2, isFirstLoad]}
                                        className="artist_name"
                                        key={item.title + "_title_eles_" + idx}
                                    >
                                        {item.artist}
                                    </motion.span>
                                ))}
                                </AnimatePresence>
                        </motion.div>
                        
                        <motion.div 
                            className="project_number_wrapper"
                            initial="initial"    
                            animate="animate"
                            exit="exit"
                        >
                            <div 
                                className="num_wrapper"
                            >
                                <AnimatePresence mode="wait">
                                {projData && projData.map((item, idx) => (
                                    idx == activeMetaInfo &&
                                    <motion.span
                                        initial="initial"
                                        animate={selectedIndex ? "projExit" : activeMetaInfo == idx && isColumnView && isPresent ? "animate" : "projExit"}
                                        exit="exit"
                                        variants={artistVariants}
                                        custom={[2.5, isFirstLoad]}
                                        className="proj_number"
                                        key={item.title + "_title_eles_" + idx}
                                    >
                                        {(idx+1) < 10 ? '0'+(idx+1).toString() : (idx+1)}
                                    </motion.span>
                                ))}
                                </AnimatePresence>
                            </div>
                            <motion.span
                            initial="initial"
                                animate={
                                    isColumnView && !selectedIndex && isPresent 
                                    ? "animate" 
                                    : !selectedIndex ? "exit" : "projExit"}
                                variants={auxProjNumVariants}
                                custom={[2.5, isFirstLoad]}
                            >&nbsp;- {projData.length}</motion.span>
                    </motion.div>
                        
                    </div>
                </div>
                <GridLayout 
                    projData={projData}
                    activeIndex={activeIndex}
                    activeMetaInfo={activeMetaInfo}
                    setActiveMetaInfo={setActiveMetaInfo}
                    slidingWindowTuple={slidingWindowTuple}
                    isColumnView={isColumnView}
                    setTriggerHomepageToProjectTransition={setTriggerHomepageToProjectTransition}
                />
            </motion.div>
            <motion.div 
                key="noise_overlay"
                className="noise_overlay" 
                ref={noiseRef}
                onMouseMove={(ev)=> (
                    handleMouseMove(ev)
                )}
                initial={{
                    opacity: 1
                }}
                animate={isFilmMode ? {
                    opacity: 1,
                    transition: {
                        duration: 1,
                        delay: 0.5,
                        ease: "easeOut"
                    }
                } : {
                    opacity: 0,
                    transition: {
                        duration: 1.5,
                        delay: 0.5,
                        ease: "easeOut"
                    }
                }}
                projExit = {{
                    opacity: 0,
                    transition: {
                        duration: 1,
                        delay: 0.5,
                        ease: "easeOut"
                    } 
                }}
                exit={{
                    opacity: 0,
                    transition: {
                        duration: dsktpExitTiming,
                        delay: 0,
                        ease: "easeOut"
                    }
                }}
            />
        </>
    )
}

export default Homepage;